/**
 * @deprecated use same function from '@rchh/lowcode-utils' instead
 */
export function isDOMText(data) {
  return typeof data === 'string';
}